import React, { useState, useCallback } from 'react';
import cn from 'classnames';
import { Container, Contacts } from 'components/UI';
import { Title } from '@landing/ui';
import Copyright from './Copyright';
import OfficeCard from './OfficeCard';
import data from 'define/footer';
import * as styles from './Footer.module.scss';

function Footer() {
  const [count, setCount] = useState(4);

  const showMore = useCallback(() => {
    setCount(prev => prev + 4);
  }, []);

  return (
    <footer className={styles.footer}>
      <div className={styles.wrapper}>
        <Container className={styles.container} background="transparent" padding="TopNone">
          <div className={styles.main}>
            <div className={cn(styles.line, styles.line_without_top)} />
            <Title tag="h3" color="white">
              {data.officeTitle}
            </Title>
            <div className={styles.officeWrapper}>
              <div className={styles.offices}>
                {data.offices?.slice(0, count).map(office => (
                  <OfficeCard key={office.name} {...office} />
                ))}
              </div>
              {count < data.offices?.length && (
                <div className={styles.showRow}>
                  <button onClick={showMore} className={styles.showMore}>
                    Show more
                  </button>
                </div>
              )}
            </div>
            <div className={styles.line} />
            <div className={styles.contactUs}>
              <Contacts />
            </div>
          </div>
        </Container>
      </div>
      <Copyright />
    </footer>
  );
}

export default Footer;
